import { render, staticRenderFns } from "./NavBarSubMenu.vue?vue&type=template&id=5963a388&scoped=true&"
import script from "./NavBarSubMenu.vue?vue&type=script&lang=js&"
export * from "./NavBarSubMenu.vue?vue&type=script&lang=js&"
import style0 from "./NavBarSubMenu.vue?vue&type=style&index=0&id=5963a388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5963a388",
  null
  
)

export default component.exports